<template>
  <BaseVeeForm :action="handleSubmit" ensure-error-keys-camel-case v-slot="{ isPending, invalid }">
    <div class="py-4 px-3 bg-green-600 rounded shadow-sm">
      <div class="flex items-center space-x-4">
        <div class="flex-shrink-0">
          <img class="h-8 w-8 rounded-full" :src="account.logo" />
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-gray-900 truncate">
            {{ account.name }}
          </p>
          <ValidationProvider rules="required" name="account" slim vid="account">
            <template #default="{ errors }">
              <BaseFormGroup>
                <BaseFormInput type="hidden" :value="account.id" readonly />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
        <div>
          <button
            class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
            :disabled="isPending || invalid"
          >
            <svg
              v-if="isPending"
              class="animate-spin h-4 w-4 mr-2 text-black inline-flex"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              />
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962
                  0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            <span class="inline-block">Unlink</span>
          </button>
        </div>
      </div>
    </div>
  </BaseVeeForm>
</template>

<script>
export default {
  props: {
    account: {
      type: Object,
      required: true,
    },
    onUnlinkAccount: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async handleSubmit() {
      try {
        await this.onUnlinkAccount(this.account);
      } catch (error) {
        //
      }
    },
  },
};
</script>
